import { useState, useEffect, useContext, useCallback  } from 'react';
import { useParams } from "react-router-dom";
import axios from 'axios';


import { CcTitle } from '../commonComponents/styledTexts';
import { Icon as Iconify } from '@iconify/react';

import ReportSnippetInfo from './snippetInfo';
import { ReportBar } from './reportBar';


const SpreadStatsViewer = (props) => {

function formatNumber(value) {
  return new Intl.NumberFormat(undefined, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
  }).format(value);
}
const getTotalOpensFromOptimisingStats = () => {
  let result = 0
  for (const stat of props.stats) {
    result += stat.numOpens
  }
  return result
}
const getProgressFromOptimisingStats = () => {
  const totalOpens = getTotalOpensFromOptimisingStats()
  if (totalOpens === 0) return 0
  else return new Intl.NumberFormat(undefined, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(totalOpens / props.threshold * 100);
}

  return <div>
          <div className='flex flex-row items-center gap-x-4'>
            <div className='text-xl text-ccColorDarkTeal font-semibold'>{props.optimisingStrategy === 'spread' ? 'Stats per image' : 'Optimise phase'}</div>
            {props.optimisingStrategy === 'optimise' && <div className='flex flex-row gap-x-1 items-center text-ccColorDarkTeal border border-ccColorDarkTeal rounded px-2'>
              {props.winnerVariantIndex >= 0 ? <>
                <Iconify icon="fluent-mdl2:completed" width={20} />
                <div>Completed</div>
              </>
              :
              <>
                <Iconify icon="mdi:run-fast" width={20} />
                <div>Running</div>
              </>              
              }
              </div>}
            {props.optimisingStrategy === 'optimise' && <div className='flex flex-row gap-x-1 items-center text-ccColorDarkTeal border border-ccColorDarkTeal rounded px-2'>
              {props.winnerVariantIndex >= 0 ? <>
                <div>Threshold: <span className='font-semibold'>{props.threshold}</span></div>
              </>
              :
              <>
                <div><span className='font-semibold'>{getProgressFromOptimisingStats()}%</span> complete</div>
                <div className='text-xs ml-2'>({getTotalOpensFromOptimisingStats()} out of {props.threshold})</div>
              </>              
              }
              </div>}
          </div>
          <div className='flex flex-col gap-y-8 items-start mt-2'>
              {props.stats?.map(s => <div className='flex flex-row gap-x-4 relative'>

                <div className='bg-slate-200 rounded p-4 w-[400px] h-[300px] flex justify-center relative'>
                    <div className='h-full' >

                        <img style={{height: 'auto', width: 'auto', maxWidth: '100%', maxHeight: '100%'}} src={`${props.images ? props.images[s.variant-1] : ''}`} />
                    </div>
                 {props.winnerVariantIndex === s.variant && <div className='absolute -right-2 -top-4 z-10'>
                          <img className='w-[64px]' src='/assets/winner.png' />
                        </div>
                }
                   
                  </div>
                  <div className='flex flex-col'> 
                    <div className='bg-ccColorDarkTeal text-white font-semibold font-poppins text-sm w-fit rounded px-2 py-1 mb-6'>Variant {s.variant}</div>
                    <div className='flex flex-row gap-x-8'>
                      <div className={`flex flex-col gap-y-2 p-2 ${props.optimisingStrategy === 'optimise' ? 'border border-ccColorDarkTeal rounded' : ''}`}>
                        {props.optimisingStrategy === 'optimise' && <div className='text-ccColorDarkTeal'>Optimise Stats</div>}
                        <div className='bg-ccColorTeal text-white font-poppins text-sm w-40 rounded pl-4 py-1'>
                          <div>Opens</div>
                          <div className='text-2xl font-semibold'>{s.numOpens}</div>
                        </div>
                        <div className='bg-ccColorTeal text-white font-poppins text-sm w-40 rounded pl-4 py-1'>
                          <div>Clicks</div>
                          <div className='text-2xl font-semibold'>{s.numClicks}</div>
                        </div>
                        <div className='bg-ccColorOrange text-white font-poppins text-sm w-40 rounded pl-4 py-1'>
                          <div>CTO</div>
                          <div className='text-2xl font-semibold'>{(s.numClicks > 0 && s.numOpens > 0) ? formatNumber(s.numClicks / s.numOpens * 100): 0}%</div>
                        </div>
                      </div>
                      {props.winnerVariantIndex === s.variant && <div className='flex flex-col gap-y-2 p-2 border border-ccColorDarkTeal rounded text-ccColorDarkTeal'>
                        <div>Post Optimise Stats</div>
                        <div className='bg-slate-100 text-ccColorDarkTeal font-poppins text-sm w-40 rounded pl-4 py-1'>
                          <div>Opens</div>
                          <div className='text-2xl font-semibold'>{props.postOptimising?.opens}</div>
                        </div>
                        <div className='bg-slate-100 text-ccColorDarkTeal font-poppins text-sm w-40 rounded pl-4 py-1'>
                          <div>Clicks</div>
                          <div className='text-2xl font-semibold'>{props.postOptimising?.clicks}</div>
                        </div>
                        <div className='bg-slate-100 text-ccColorDarkTeal font-poppins text-sm w-40 rounded pl-4 py-1'>
                          <div>CTO</div>
                          <div className='text-2xl font-semibold'>{(props.postOptimising?.clicks > 0 && props.postOptimising?.opens > 0) ? formatNumber(props.postOptimising?.clicks / props.postOptimising?.opens * 100) : 0}%</div>
                        </div>
                        </div>}
                    </div>
                  </div>
              </div>)

              }
          </div>
      </div>
}

export default function SnippetImageOptimiserReport(props) {
    const [showLoader, setShowLoader] = useState(false)
    const [snippetInfo, setSnippetInfo] = useState(undefined)
    const [stats, setStats] = useState(undefined)
    const [imgUrls, setImgUrls] = useState(undefined)
    const [threshold, setThreshold] = useState(0)

  let params = useParams();
      
  useEffect(() => {
      //console.log(params)
    if (params.snippetId !== undefined) {
        setSnippetInfo(undefined)
        setImgUrls(undefined)
        getSnippetStats(params.snippetId)
        getSnippetInfo(params.snippetId)
    }
  }, [params])

  const getSnippetStats = async (snippetId) => {
    try {  
      const url = `${process.env.REACT_APP_LION_API_URL}/Stats/element/imgOptimiser/${snippetId}`;
      const response = await axios.get(url);
      const data = response.data;

      //console.log(data)
      setStats(data)

    } catch (error) {
      console.log(error);
    }
  }
  const getSnippetInfo = async (snippetId) => {
    try {  
      const url = `${process.env.REACT_APP_LION_API_URL}/Snippets/${snippetId}`;
      const response = await axios.get(url);
      const data = response.data;

      //console.log(data)
      setSnippetInfo(data)
      const settings = JSON.parse(data.snippetSettings)
      setImgUrls(settings.images.map(i => i.imgB64))
      setThreshold(settings.strategy.threshold)

    } catch (error) {
      console.log(error);
    }
  }


    return <div>
            <CcTitle>Image Optimiser Report</CcTitle>
            <div className='mt-4'>
                <ReportSnippetInfo snippetInfo={snippetInfo} />
            </div>
            <div className='mt-4'>
                <ReportBar stats={[{title: 'Total Views', value: stats?.totalOpens},
                                    {title: 'Total Clicks', value: stats?.totalClicks},
                                    {title: 'Number of variants', value: stats?.numVariants},
                                    {title: 'Strategy', value: stats?.optimisingStrategy},
                                    ]} />
            </div>
            <div className='mt-6'>
              <SpreadStatsViewer stats={stats?.variantStats}
                      winnerVariantIndex={stats?.winnerVariantIndex}
                      images={imgUrls}
                      optimisingStrategy={stats?.optimisingStrategy}
                      postOptimising={{opens: stats?.winnerPostOptimisingOpens, clicks: stats?.winnerPostOptimisingClicks}}
                      threshold={threshold}
               />

            </div>
    </div>
}